export const JavaScript = [
    {
        question: "Which method is used to find an HTML element by its ID?",
        option1: "getElementByClass()",
        option2: "getElementById()",
        option3: "getElementByTag()",
        option4: "querySelector()",
        ans: 2,
    },
    {
        question: "Which method is used to create a new element in the DOM?",
        option1: "createElement()",
        option2: "newElement()",
        option3: "appendChild()",
        option4: "createNode()",
        ans: 1,
    },
    {
        question: "What does the call stack do in JavaScript?",
        option1: "Handles asynchronous operations",
        option2: "Tracks function calls and manages function execution",
        option3: "Manages memory allocation",
        option4: "Optimizes code performance",
        ans: 2,
    },
    {
        question: "Which of the following is a way to handle asynchronous operations in JavaScript?",
        option1: "Promises",
        option2: "Callbacks",
        option3: "Async/Await",
        option4: "All of the above",
        ans: 4,
    },
    {
        question: "What does the 'async' keyword do in JavaScript?",
        option1: "Declares an asynchronous function",
        option2: "Pauses the execution of the function",
        option3: "Makes the function run synchronously",
        option4: "Declares a variable",
        ans: 1,
    },
    {
        question: "Which method is used to add an element at the end of a list of child nodes?",
        option1: "appendChild()",
        option2: "insertBefore()",
        option3: "replaceChild()",
        option4: "addChild()",
        ans: 1,
    },
    {
        question: "What does the 'await' keyword do in JavaScript?",
        option1: "Makes the function run asynchronously",
        option2: "Pauses the execution of the async function",
        option3: "Declares a synchronous function",
        option4: "Creates a promise",
        ans: 2,
    },
    {
        question: "Which of the following methods is used to send an HTTP request in JavaScript?",
        option1: "fetch()",
        option2: "getRequest()",
        option3: "postRequest()",
        option4: "sendRequest()",
        ans: 1,
    },
    {
        question: "What is the purpose of the 'finally' block in a Promise?",
        option1: "It runs after the promise is resolved",
        option2: "It runs after the promise is rejected",
        option3: "It runs after the promise is settled (either resolved or rejected)",
        option4: "It runs before the promise is settled",
        ans: 3,
    },
    {
        question: "What is the output of the following code: console.log('Hello'); setTimeout(() => console.log('World'), 0); console.log('!');",
        option1: "Hello World !",
        option2: "World Hello !",
        option3: "Hello ! World",
        option4: "Hello ! World",
        ans: 3,
    }
];
